export const BNYMELLON = "bnymellon";
export const ACCESSPORTALS = "accessportals";
